module.exports = __webpack_public_path__ + "img/trawenagh-medium.4f0f85c1.jpg";